<template>
  <el-tag size="small" :type="type">
    {{ title }}
  </el-tag>
</template>
<script lang="ts">
import { defineComponent, computed } from 'vue'
import { AdType } from '@/api/types'

const TYPES: Record<number, string> = {
  1: 'danger',
  2: 'warning',
  10: 'primary',
  6: 'success',
  9: 'info',
  [AdType.Tab]: 'primary'
}

export default defineComponent({
  name: 'AdTypeLable',
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  setup(props, context) {
    const type = computed(() => {
      return TYPES[Number(props.id)]
    })
    return { type }
  }
})
</script>
<style lang="scss" scoped>
.el-tag {
  border: none !important;
  font-weight: 500;
}
</style>
